import React, { useEffect, useState } from 'react'
import EssLayout from '../../../../layout/components/ESSLayout'
import TaskForm from '../../../admin/erp/tasks/components/TaskForm'
import { useEssAppData } from '../../../../context/AppESSDataContext'
import TaskCardListView from '../../../admin/erp/tasks/components/TaskCardListView';
import TaskListView from '../../../admin/erp/tasks/components/TaskListView';
import TaskFilterToolBar from '../../../admin/erp/tasks/hook/TaskFilterToolBar';
import { CalendarMonth, TableChart, ViewStream } from '@mui/icons-material';
import { useTaskFilters } from '../../../admin/erp/tasks/hook/useTaskFilter';
import { useAuth } from '../../../../context/AuthContext';
import TaskCalendarView from '../../../admin/erp/tasks/components/TaskCalendarView';
import TaskActivityList from '../../../admin/erp/tasks/components/TaskActivityList';
import { Link } from 'react-router-dom';

function EssArchivedTaskPage() {
  const {getTaskList,archivedTaskList,getArchivedTaskList} = useEssAppData();
  const { authUser } = useAuth();
  const [selectedView,setSelectedView] = useState("card")
  
  useEffect(()=>{
    getArchivedTaskList();
  },[])

  const archivedCallBack = () =>{
    getArchivedTaskList();
    getTaskList();
  }

  return (
    <EssLayout>
        <div className='container-fluid'>
            <div className='row'>
                    <div className='col-md-12'>
                        <div className='row align-items-center mb-0'>
                            
                            <div className='col-6'>
                                <div className="btn-group" role="group">
                                    <button type="button" className={selectedView === "card" ? "btn btn-primary" : "btn btn-outline-primary"} onClick={()=>setSelectedView("card")}  ><ViewStream/> </button>
                                    <button type="button" className={selectedView === "tabular" ? "btn btn-primary" : "btn btn-outline-primary"} onClick={()=>setSelectedView("tabular")}  ><TableChart/> </button>
                                    <button type="button" className={selectedView === "calendar" ? "btn btn-primary" : "btn btn-outline-primary"} onClick={()=>setSelectedView("calendar")}  ><CalendarMonth/></button>
                                </div>
                            </div>
                            <div className='col-md-6'>
                                <span className=''><Link to="/task" className='ms-2 btn btn-outline-success'>Show Active Task List</Link></span>
                            </div>
                        </div>
                        
                        <div className='row'>
                            <div className='col-md-12' style={{maxHeight:"80vh", overflow:"scroll" }}>
                                {selectedView === "tabular" && <TaskListView taskList={archivedTaskList} callBack={archivedCallBack} /> }
                                {selectedView === "card" && <TaskCardListView taskList={archivedTaskList} callBack={archivedCallBack} /> }
                                {selectedView === "calendar" && <TaskCalendarView taskList={archivedTaskList} callBack={archivedCallBack} /> }
                            </div>
                        </div>
                        
                    </div>
                </div>
        </div>
    </EssLayout>
    
  )
}

export default EssArchivedTaskPage